import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Layout = ({ children }) => {
  const { user, logout, isAdmin, isAdminOrTis } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    { path: '/', label: 'Dashboard', icon: '📊', show: true },
    { path: '/work-orders', label: 'İş Emirleri', icon: '📋', show: true },
    { path: '/companies', label: 'Firmalar', icon: '🏢', show: true },
    { path: '/users', label: 'Kullanıcılar', icon: '👥', show: isAdmin() },
    { path: '/qc', label: 'QC Talepleri', icon: '✅', show: isAdminOrTis() },
    { path: '/extensions', label: 'Ek Süre Talepleri', icon: '⏰', show: true },
    { path: '/scoring', label: 'Puan Kuralları', icon: '⭐', show: isAdmin() },
    { path: '/notifications', label: 'Bildirim Ayarları', icon: '🔔', show: isAdminOrTis() },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <aside className={`${sidebarOpen ? 'w-64' : 'w-20'} bg-white shadow-lg transition-all duration-300`}>
        <div className="p-4 border-b">
          <h1 className={`font-bold text-xl text-blue-600 ${!sidebarOpen && 'text-center'}`}>
            {sidebarOpen ? 'Fason Takip' : 'FT'}
          </h1>
        </div>

        <nav className="mt-4">
          {menuItems.filter(item => item.show).map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center px-4 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors
                ${isActive(item.path) ? 'bg-blue-50 text-blue-600 border-r-4 border-blue-600' : ''}`}
            >
              <span className="text-xl">{item.icon}</span>
              {sidebarOpen && <span className="ml-3">{item.label}</span>}
            </Link>
          ))}
        </nav>

        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="absolute bottom-4 left-4 p-2 text-gray-500 hover:text-gray-700"
        >
          {sidebarOpen ? '◀' : '▶'}
        </button>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Bar */}
        <header className="bg-white shadow-sm px-6 py-4 flex justify-between items-center">
          <div>
            <input
              type="text"
              placeholder="Ara... (İş No, Firma)"
              className="px-4 py-2 border rounded-lg w-80 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="flex items-center space-x-4">
            <div className="text-right">
              <p className="font-medium text-gray-800">{user?.name}</p>
              <p className="text-sm text-gray-500">
                {user?.userType === 'admin' ? 'Admin' :
                  user?.userType === 'tis' ? 'TİS' : 'İmalatçı'}
              </p>
            </div>
            <button
              onClick={handleLogout}
              className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
            >
              Çıkış
            </button>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-auto p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
